import { gql } from '@apollo/client';
import type { PaymentStatusValue } from '../../../utils/bookingOrderHelpers';

/**
 * Persist manual payment status on a WooCommerce order (order meta + isPaid flag).
 * Booking status remains independent on order.status.
 */
export const UPDATE_ORDER_PAYMENT_STATUS = gql`
  mutation UpdateOrderPaymentStatus(
    $orderId: Int!
    $metaData: [MetaDataInput]
    $isPaid: Boolean
  ) {
    updateOrder(input: { orderId: $orderId, metaData: $metaData, isPaid: $isPaid }) {
      order {
        databaseId
        status
        metaData {
          key
          value
        }
      }
    }
  }
`;

export interface UpdateOrderPaymentStatusData {
  updateOrder: {
    order: {
      databaseId: number;
      status: string;
      metaData?: Array<{ key: string; value: string }>;
    } | null;
  } | null;
}

export interface UpdateOrderPaymentStatusVariables {
  orderId: number;
  metaData: Array<{ key: string; value: PaymentStatusValue }>;
  isPaid: boolean;
}
